export default function BaseCard({ children, classNames }) {
    return <div className={`cot-base-card ${classNames || ""}`}>{children}</div>;
}
